import axios from '../axiosAlertConfig';

const BASE = '/student-accommodations';

function scopeParams(scope = {}) {
  return {
    iAccountID: String(scope.iAccountID || '').trim(),
    iCampusID: String(scope.iCampusID || '').trim() || '-99',
    iBuildingID: String(scope.iBuildingID || '').trim(),
    districtSearch: scope.districtSearch === true || scope.districtSearch === 'true' || scope.districtSearch === 1 || scope.districtSearch === '1',
    incidentID: String(scope.incidentID || '').trim(),
    readOnly: scope.readOnly === true || scope.readOnly === 'true' || scope.readOnly === 1 || scope.readOnly === '1',
  };
}

export async function getStudentAccommodation(studentId, scope) {
  const { data } = await axios.get(`${BASE}/students/${encodeURIComponent(studentId)}`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function saveStudentAccommodation(studentId, scope, plan, expectedRevision) {
  const { data } = await axios.put(`${BASE}/students/${encodeURIComponent(studentId)}`, {
    ...scopeParams(scope),
    plan,
    expectedRevision,
  });
  return data;
}

export async function getAdultResidentialExtension(studentId, scope) {
  const { data } = await axios.get(`${BASE}/students/${encodeURIComponent(studentId)}/adult-residential-extension`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function saveAdultResidentialExtension(studentId, scope, extension, expectedRevision) {
  const { data } = await axios.put(`${BASE}/students/${encodeURIComponent(studentId)}/adult-residential-extension`, {
    ...scopeParams(scope),
    extension,
    expectedRevision,
  });
  return data;
}

export async function listStudentAccommodationDisclosures(studentId, scope) {
  const { data } = await axios.get(`${BASE}/students/${encodeURIComponent(studentId)}/disclosures`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function addStudentAccommodationDisclosure(studentId, scope, disclosure, expectedRevision) {
  const { data } = await axios.post(`${BASE}/students/${encodeURIComponent(studentId)}/disclosures`, {
    ...scopeParams(scope),
    disclosure,
    expectedRevision,
  });
  return data;
}

export async function listStudentAccommodationReviews(studentId, scope) {
  const { data } = await axios.get(`${BASE}/students/${encodeURIComponent(studentId)}/reviews`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function addStudentAccommodationReview(studentId, scope, review, expectedRevision) {
  const { data } = await axios.post(`${BASE}/students/${encodeURIComponent(studentId)}/reviews`, {
    ...scopeParams(scope),
    review,
    expectedRevision,
  });
  return data;
}

export async function updateStudentAccommodationReviewCorrectiveAction(studentId, reviewId, scope, correctiveAction, expectedRevision) {
  const { data } = await axios.patch(
    `${BASE}/students/${encodeURIComponent(studentId)}/reviews/${encodeURIComponent(reviewId)}/corrective-action`,
    {
      ...scopeParams(scope),
      correctiveAction,
      expectedRevision,
    }
  );
  return data;
}

export async function listAccommodationStaff(scope) {
  const { data } = await axios.get(`${BASE}/staff-options`, { params: scopeParams(scope) });
  return data;
}

export async function getAccommodationSummary(scope) {
  const { data } = await axios.get(`${BASE}/summary`, { params: scopeParams(scope) });
  return data;
}

export async function listAccommodationRoster(scope) {
  const { data } = await axios.get(`${BASE}/roster`, { params: scopeParams(scope) });
  return data;
}

export async function getAccommodationScopeInfo(scope) {
  const { data } = await axios.get(`${BASE}/scope-info`, { params: scopeParams(scope) });
  return data;
}

export async function listAccommodationDocuments(scope) {
  const { data } = await axios.get(`${BASE}/documents`, { params: scopeParams(scope) });
  return data;
}

export async function getAccommodationDocumentViewUrl(documentId, scope) {
  const { data } = await axios.get(`${BASE}/documents/${encodeURIComponent(documentId)}/view-url`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function uploadAccommodationDocument(scope, scopeType, file, resolvedCampusID = null) {
  const form = new FormData();
  const values = scopeParams({ ...scope, iCampusID: resolvedCampusID || scope?.iCampusID });
  Object.entries(values).forEach(([key, value]) => form.append(key, value));
  form.append('scopeType', scopeType);
  form.append('file', file);
  const { data } = await axios.post(`${BASE}/documents`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteAccommodationDocument(documentId, scope) {
  const { data } = await axios.delete(`${BASE}/documents/${encodeURIComponent(documentId)}`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function listOperationalAccommodationStudents(scope) {
  const { data } = await axios.get(`${BASE}/operational/building`, {
    params: { ...scopeParams(scope), incidentID: String(scope?.incidentID || '').trim() },
  });
  return data;
}

export async function listAccommodationWorkspace(scope, filters = {}) {
  const { data } = await axios.get(`${BASE}/workspace`, { params: { ...filters, ...scopeParams(scope) } });
  return data;
}

export async function listAccommodationStudentStatus(scope, studentIds) {
  const { data } = await axios.get(`${BASE}/student-status`, {
    params: { ...scopeParams(scope), studentIds: (studentIds || []).join(',') },
  });
  return data;
}

export async function listStudentAccommodationChangeHistory(studentId, scope) {
  const { data } = await axios.get(`${BASE}/students/${encodeURIComponent(studentId)}/change-history`, {
    params: scopeParams(scope),
  });
  return data;
}

export async function updateAccommodationSpecialStatus(studentId, scope, payload, expectedRevision) {
  const { data } = await axios.put(`${BASE}/students/${encodeURIComponent(studentId)}/special-status`, {
    ...payload, ...scopeParams(scope), expectedRevision,
  });
  return data;
}

export function publishAccommodationChange(scope, student) {
  window.dispatchEvent(new CustomEvent('student-accommodations-changed', {
    detail: { ...scopeParams(scope), studentId: student?.studentId, student },
  }));
}
